export const getRandomProgress = () => {
  return Math.floor(Math.random() * 50);
};
